// extracted by mini-css-extract-plugin
export default {"material-tables":"review_material-tables__CDwDA","head2":"review_head2__AFKQs","material-table":"review_material-table__wMUtN","clickable":"review_clickable__ZbvMS"};